import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export interface TelconaCredentialsDTO extends z.infer<typeof TelconaCredentialsDTORuntype> {}
export const TelconaCredentialsDTORuntype = z.object({
    client_id: z.string(),
    api_key: z.string(),
});

export interface TelconaCredentialsInputDTO extends z.infer<typeof TelconaCredentialsInputDTORuntype> {}
export const TelconaCredentialsInputDTORuntype = z.object({
    client_id: z.string().optional(),
    api_key: z.string().optional(),
});

export interface TelconaResponseBodyDTO extends z.infer<typeof TelconaResponseBodyDTORuntype> {}
export const TelconaResponseBodyDTORuntype = z.object({
    data: TelconaCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
